<img src="./assets/images/ononTig.png" alt="Onon字体 - 蒙古文无衬线报体" style="display: none;">
<header>
    <app-nav></app-nav>
</header>
<main>
    <router-outlet></router-outlet>
</main>
<footer class="bg-a">
    <div class="footer">
        <div class="container d-flex flex-wrap justify-content-between ">
            <div class="footer-left">
                <div class="footer-information  d-flex  flex-column">
                    <div class="section-title">
                        <h2 class="footer-title text-white font-gq">
                            联系我们
                        </h2>
                    </div>
                    <!-- footer Left Start -->
                    <div class="footer-us-single-item d-flex">
                        <div class="footer-icon">
                            <img src="../assets/images/footer/cal.png" alt="Onon字体 - Calennder" />
                        </div>
                        <ul class="working-hour work-info">
                            <li class="d-flex justify-content-between">
                                <div class="work-day">周一 至 周五</div>
                                <div class="work-time">9:00 - 18:00</div>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-us-single-item d-flex">
                        <div class="footer-icon width-18">
                            <img src="../assets/images/footer/map.png" alt="Onon字体 - map" />
                        </div>
                        <div class="work-info position_hover" (click)="Position()">
                            内蒙古自治区呼和浩特市回民区大学西街71号银都大厦B座801-803室
                        </div>
                    </div>
                    <div class="footer-us-single-item d-flex">
                        <div class="footer-icon">
                            <img src="../assets/images/footer/at.png" alt="Onon字体 - Telephone" />
                        </div>
                        <div class="work-info">dev@onon.cn</div>
                    </div>
                    <div class="footer-us-single-item d-flex">
                        <div class="footer-icon">
                            <img src="../assets/images/footer/tel.png" alt="Onon字体 - Telephone" />
                        </div>
                        <div class="work-info">0471-5216653</div>
                    </div>
                </div>
            </div>
            <div class="footer-right">
                <div class="footer-right-cont">
                    <ul class="d-flex flex-wrap footer-title">
                        <li class="margin-0-10">
                            产品中心
                            <ul>
                                <li><a href="https://doc.onon.cn/" target="_blank">Onon文库</a></li>
                                <li><a href="https://map.onon.cn" target="_blank">Onon地图</a></li>
                                <li><a href="http://office.onon.cn" target="_blank">Onon办公套装</a></li>
                                <li><a href="http://ime.onon.cn" target="_blank">Onon输入法</a></li>
                                <!-- <li><a href="http://cat.onon.cn" target="_blank">辅助翻译</a></li> -->
                                <!-- <li><a href="http://mt.onon.cn/" target="_blank">机器翻译</a></li> -->
                                <!-- <li><a href="http://dic.onon.cn/" target="_blank">开放词典</a></li> -->
                                <li><a href="http://www.onon.cn/cn/home#product" target="_blank">了解更多>></a></li>
                            </ul>
                        </li>
                        <li class="margin-0-10">
                            技术服务
                            <ul>
                                <li><a href="http://help.onon.cn" target="_blank">帮助文档</a></li>
                                <li></li>
                            </ul>
                        </li>
                        <li class="margin-0-10">
                            关于我们
                            <ul>
                                <li><a href="https://www.onon.cn" target="_blank">Onon官网</a></li>
                                <li><a href="https://www.onon.cn/cn/recruit" target="_blank">加入我们</a></li>
                                <li><a href="https://www.onon.cn/cn/news" target="_blank">媒体报道</a></li>
                                <li><a href="https://www.onon.cn/cn/qualification" target="_blank">资质荣誉</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="margin-20-0">
                    <ul class="footer-title d-flex flex-wrap">
                        <li class="margin-0-10">
                            微信小程序
                            <ul class="d-flex flex-wrap">
                                <li class="d-flex flex-column ">
                                    <span>Onon文库</span>
                                    <img class="footer-ewm" src="../assets/images/footer/mpcode2.png" alt="Onon字体 - QRcode">
                                </li>
                                <li class="d-flex flex-column margin-0-10">
                                    <span>Onon地图</span>
                                    <img class="footer-ewm" src="../assets/images/footer/map_QRcode.jpg" alt="Onon字体 - QRcode">
                                </li>
                                <li class="d-flex flex-column">
                                    <span>Onon习语</span>
                                    <img class="footer-ewm" src="/assets/images/footer/xy_QRcode.jpg" alt="Onon字体 - QRcode">
                                </li>
                            </ul>
                        </li>
                        <!-- <li class="footer-title">
                            &nbsp;
                            <ul class="d-flex ">
                                <li class="d-flex flex-column">
                                    <span>Onon习语</span>
                                    <img class="footer-ewm" src="/assets/images/footer/xy_QRcode.jpg" alt="">
                                </li>
                            </ul>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container position-relative">
        <div class="foot-info d-flex flex-wrap justify-content-between align-items-center">
            <div class="foot-logo">
                <a [routerLink]="['/index']">
                    <img src="/assets/images/onon-logo-font.png" alt="Onon字体 - Logo" />
                </a>
            </div>
            <div class="foot-text text-center">
                <div>基础研究：<a href="http://www.nmgass.com.cn/" target="_blank">内蒙古自治区社会科学院</a></div>
                <div>成果转化：<a href="http://www.onon.cn" target="_blank">内蒙古斡仑科技有限公司</a></div>
                <div>©{{today | date:"yyyy"}}&nbsp;&nbsp;
                    <a href="https://beian.miit.gov.cn/" target="_blank">蒙ICP备18002860</a></div>
            </div>
            <div class="f_d">
                <img class="footer-erwei" src="/assets/images/footer/gz.jpg" alt="Onon字体 - 微信公众号">
            </div>
        </div>
    </div>
</footer>